//
import { useState } from "react";
import { useQuery } from "react-query";
import { getCategory, getSubCategory } from "./newProductsApi";

//
const useNewProduct = () => {
  //
  const [showModalQuickView, setShowModalQuickView] = useState(false);
  //
  //
  const { data: category } = useQuery("getCategoryList", getCategory, {
    staleTime: 15 * (60 * 1000),
  });
  // 
  const { data: sub_category } = useQuery(
    "getSubCategoryList",
    getSubCategory,
    { staleTime: 15 * (60 * 1000), cacheTime: 18 * (60 * 1000) }
  );
  //
  return {
    category,
    sub_category,
    setShowModalQuickView,
    showModalQuickView,
  };
};

export default useNewProduct;
